import { getAccessUrl } from './getAccessUrl';
import { setWindowLocation } from './setWindowLocation';

export const redirectToAccess = (region: string, pathname: string = '') => {
  const endpoint = getAccessUrl(region);

  setWindowLocation(`${endpoint}${pathname}`);
};
